import React, { useCallback, useRef } from 'react';

import { useBottomDrawerUIState } from '@rbilabs/components-library/build/components/bottom-drawer';

import { useEffectOnce } from 'hooks/use-effect-once';
import { useCdpContext } from 'state/cdp';
import { ClickEventComponentNames, CustomEventNames, EventTypes } from 'state/cdp/constants';
import { useLocationContext } from 'state/location';

import { LoyaltyPromoCodeCTA } from './loyalty-promo-code-cta';
import { LoyaltyPromoCodeDrawer } from './loyalty-promo-code-drawer';
import { IPromoCodeProps } from './types';

export const LoyaltyPromoCode = ({
  onPromoCodeRedeemSuccess,
  CTAComponent,
  CTAText,
  isV2 = false,
}: IPromoCodeProps) => {
  const dialogState = useBottomDrawerUIState();
  const { trackEvent } = useCdpContext();
  const { location } = useLocationContext();
  const queryParams = new URLSearchParams(location.search);

  const promoCode = queryParams.get('promoCode');
  const promoCodeRef = useRef('');

  const setPromoCodeRef = useCallback((promoCodeValue: string) => {
    promoCodeRef.current = promoCodeValue;
  }, []);

  const onDismiss = useCallback(() => {
    promoCodeRef.current = '';
  }, []);

  const onOpenHandler = () => {
    trackEvent({
      name: CustomEventNames.CLICK_EVENT,
      type: EventTypes.Other,
      attributes: {
        component: ClickEventComponentNames.PROMO_CODE_TILE,
        text: 'Have a Promo Code?',
      },
    });
    dialogState.show();
  };

  useEffectOnce(() => {
    if (!dialogState.visible && promoCode) {
      dialogState.show();
    }
  });

  return (
    <>
      {CTAComponent ? (
        <CTAComponent onClick={onOpenHandler}>{CTAText}</CTAComponent>
      ) : (
        <LoyaltyPromoCodeCTA onClick={onOpenHandler} />
      )}
      <LoyaltyPromoCodeDrawer
        onDismiss={onDismiss}
        dialogState={dialogState}
        setPromoCodeRef={setPromoCodeRef}
        onPromoCodeRedeemSuccess={onPromoCodeRedeemSuccess}
        promoCode={promoCode || promoCodeRef.current}
        isV2={isV2}
      />
    </>
  );
};
